import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { SMLThemeSwitch } from '../../../music24/components/SMLThemeSwitch';
import { Music24FullLogo } from '../../../music24/components/Music24FullLogo';
import { AuthMode } from './AuthEmailHeading';
import { authV2Messages } from './authV2Messages';
import { withBrandWord } from '../../../music24/components/primitives/BrandWord';
import { LanguagePicker } from '../../../app/locale/LanguagePicker';

interface AuthTopBarProps {
  mode: AuthMode;
  /** null hides the mode switch (the invite variant, the code step). */
  onSwitchMode: ((mode: AuthMode) => void) | null;
}

/**
 * The brand, the "Sign in" / "Start free" switch, the language picker (QA 2026-10-28, lit-1: a
 * visitor who reads no English finds the own language here) and the theme (design: onboarding g1,
 * g10, `.ob-top`).
 */
const AuthTopBarComponent: React.FC<AuthTopBarProps> = ({ mode, onSwitchMode }) => {
  const intl = useIntl();
  const isSignin = mode === 'signin';
  return (
    <header className="au-top">
      <span className="au-brand">
        <Music24FullLogo size={26} />
      </span>
      <div className="au-who">
        {onSwitchMode !== null ? (
          <>
            <span className="au-who-q">
              {withBrandWord(intl.formatMessage(isSignin ? authV2Messages.topNew : authV2Messages.topHaveAccount))}
            </span>
            <button type="button" className="au-link" onClick={() => onSwitchMode(isSignin ? 'signup' : 'signin')}>
              {intl.formatMessage(isSignin ? authV2Messages.topStartFree : authV2Messages.topSignIn)}
            </button>
          </>
        ) : null}
        <LanguagePicker mode="visitor" />
        <SMLThemeSwitch variant="icon" direction="down" align="end" />
      </div>
    </header>
  );
};

export const AuthTopBar = TypedMemo(AuthTopBarComponent);
